import React, { useState, useEffect } from 'react';
import ClientLayout from '../layouts/ClientLayout';
import { API_URL } from '../config';
import RoleLiveMap from '../components/RoleLiveMap';

// Client Live Map - shows only this client's own loads in transit.
function ClientLiveMap({ onLogout }) {
  const [user, setUser] = useState({});
  const [clientId, setClientId] = useState(null);
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    setUser(userData);

    const resolveClient = async () => {
      try {
        const res = await fetch(`${API_URL}/clients?user_id=${userData.id}`);
        const data = await res.json();
        if (data.success && data.clients && data.clients.length > 0) {
          const client = data.clients[0];
          setClientId(client.id);
          setCompanyName(client.company_name || '');
        }
      } catch (err) {
        console.error('Resolve client id error:', err);
      }
    };

    if (userData.id) resolveClient();
  }, []);

  return (
    <ClientLayout activeTab="livemap" onLogout={onLogout} user={user}>
      <RoleLiveMap
        filterBy="client"
        ownerId={clientId}
        title={`Live Loads${companyName ? ` — ${companyName}` : ''}`}
        subtitle="Your loads in transit (auto-refreshes every 15s)"
      />
    </ClientLayout>
  );
}

export default ClientLiveMap;